import { useFormContext, useFormField } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import { BodyText, LabelText } from '@calendly/ui/components/typography';
import { RadioField } from '@calendly/ui/form/radio-field';
import { getSummary } from 'components/event_type_edit/lock_timezone/get_summary';
import { TimezonePicker } from 'components/event_type_edit/lock_timezone/picker';
import { useEventType } from 'features/event_type_provider';

/* Figma Additional settings → Time zone display: stacked radio options with
 * label + description. Use CUI RadioField so the control keeps a fixed 16px
 * circle (flex-shrink: 0) and matches radio + text optical alignment. */
const timezoneOptionsCss = "ta38drl";
const timezoneFieldGroupCss = "t1gvsh4h";
const TimezoneOption = ({
  description,
  label,
  value
}) => {
  const [{
    checked
  },, {
    setValue
  }] = useFormField({
    name: 'lockTimezoneStatus',
    type: 'radio',
    value
  });
  return <RadioField checked={checked} description={description} label={label} name="lockTimezoneStatus" value={value} onChange={() => setValue(value)} />;
};
const TimezoneSectionLocked = () => {
  const {
    values: {
      lockTimezoneStatus
    }
  } = useFormContext();
  return <div className={timezoneFieldGroupCss} data-testid="timezone-display-locked">
      <LabelText size="large">
        {I18n.t('publisher.event_type_editor_crud.availability.timezone_display_label')}
      </LabelText>
      <BodyText size="medium">{getSummary(lockTimezoneStatus)}</BodyText>
    </div>;
};
const TimezoneSectionEditable = () => {
  const eventType = useEventType();
  const {
    owner_type: ownerType,
    isMETParent
  } = eventType;
  const showLockTimezonePicker = ownerType !== 'User' && !isMETParent;
  return <div className={timezoneFieldGroupCss} data-testid="timezone_display_section">
      <LabelText size="large">
        {I18n.t('publisher.event_type_editor_crud.availability.timezone_display_label')}
      </LabelText>
      <div className={timezoneOptionsCss} role="radiogroup" aria-label={I18n.t('publisher.event_type_editor_crud.availability.timezone_display_label')}>
        <TimezoneOption description={I18n.t('publisher.event_type_editor_crud.availability.timezone_auto_detect_description')} label={I18n.t('publisher.event_type_editor_crud.availability.timezone_auto_detect_label')} value="local" />
        <TimezoneOption description={I18n.t('publisher.event_type_editor_crud.availability.timezone_lock_description')} label={I18n.t('publisher.event_type_editor_crud.availability.timezone_lock_label')} value="locked" />
      </div>
      {showLockTimezonePicker && <TimezonePicker />}
    </div>;
};
export const TimezoneSection = ({
  isLocked = false
}) => isLocked ? <TimezoneSectionLocked /> : <TimezoneSectionEditable />;

require("./timezone_section.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./timezone_section.js");